import { AppQuiz, AppQuizVariables } from 'globalTypes'

import { useQuery } from '@apollo/client'
import Loader from 'Root/Loader'

import StateContext from './StateContext'
import Usage from './Usage'
import QUERY from './app-quiz.graphql'

const Quiz = ({
  identifier,
  collectionContent = undefined,
  setIsCompleted = () => {},
}) => {
  // we need to fetch initial content and status from server
  const { data, loading } = useQuery<AppQuiz, AppQuizVariables>(QUERY, {
    variables: {
      identifier,
    },
  })

  if (loading) {
    return (
      <div className="p-5 bg-white">
        <Loader className="h-6 w-6 mx-auto text-indigo-600" />
      </div>
    )
  }

  if (!collectionContent && data?.content?.__typename !== 'QuizContent') {
    // we shouldn't be here
    return null
  }

  // and once ready we can serve the quiz
  // based on the subtype
  return (
    <StateContext content={collectionContent || data.content}>
      <Usage setIsCompleted={setIsCompleted} />
    </StateContext>
  )
}

export default Quiz
